import { useEffect, useState } from "react";

// Detects coarse pointer / small viewport to disable heavy 3D & custom cursor.
export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const check = () => {
      const coarse = window.matchMedia("(hover: none), (pointer: coarse)").matches;
      setIsMobile(coarse || window.innerWidth < 768);
    };
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);
  return isMobile;
};
